import { Component, Input } from '@angular/core';

@Component({
    selector: 'ssf-section',
    template: require('./section.component.html'),
    styles: [require('./section.component.scss')]
})
export class SectionComponent {
    @Input() title: string;
    @Input() helpBubble: string;
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/modules/shared/components/section/section.component.ts